<nb-card>
  <nb-card-body>

    <ng2-smart-table  [settings]="settings" [source]="data" (userRowSelect)="onRowSelect($event)"  >
    </ng2-smart-table>



  </nb-card-body>
</nb-card>